import React, {useLayoutEffect} from "react";
import {useAuthDispatcher} from "../context/AuthContext";
import {actionTypes, setLoginStateDispatch} from "../context/reducer";
import {
    getUserRefreshToken,
    readFundId,
    readFundName,
    setUserRefreshToken
} from "../service/localStorage/LocalStorageService";
import jwt from "jwt-decode";
import {LoginService} from "../connection-services/login/LoginService";


export default function AuthorizationRoute(props) {

    const refreshToken = getUserRefreshToken()
    const dispatch = useAuthDispatcher()
    const service = new LoginService()


    useLayoutEffect(() => {
        if (typeof service !== 'undefined') {
            if (refreshToken !== null) {
                service.getUserTokenByRefreshToken(refreshToken)
                    .then(response => {

                        setUserLoginState(
                            response.data,
                            readFundId(),
                            readFundName(),
                            jwt(response.data.access_token).total_owner === true
                        )


                    }).catch(reason => {
                    dispatch({
                        type: actionTypes.LOGOUT,
                        loading: false,
                        loginState: false,
                        role: []
                    })
                })
            } else {
                dispatch({
                    type: actionTypes.LOGOUT,
                    loading: false,
                    loginState: false,
                    role: []
                })
            }
        }
    }, [dispatch, refreshToken])


    /*function getAvailableCashList(loginInfo) {
        if (jwt(loginInfo.access_token).total_owner === true) {
            new GeneralService()
                .getAvailableCashList(0, 1)
                .then(response => {
                    if (response.data.length > 0) {
                        setUserLoginState(
                            loginInfo,
                            response.data[0].id,
                            response.data[0].name,
                            true
                        )
                    }
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            })
        } else {
            new CashService()
                .getAvailableCashList()
                .then(response => {
                    if (response[0]) {
                        setUserLoginState(
                            loginInfo,
                            response[0].id,
                            response[0].name,
                            false
                        )
                    } else {
                        showErrorMessage("مدیریت هیچ صندوقی به شما تعلق نگرفته است!")
                    }
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            })
        }
    }*/

    function setUserLoginState(loginInfo, fundId, title, totalOwner) {
        setUserRefreshToken(loginInfo.refresh_token)
        dispatch(
            setLoginStateDispatch(
                actionTypes.LOGIN,
                loginInfo.access_token,
                "ADMIN",
                fundId,
                title,
                totalOwner
            ))
    }

    return (<>{props.children}</>)
}